import * as React from 'react';

interface IJumbotronProps {
  children: any;
  type?: string;
  background?: string;
}

const Jumbotron = (props: IJumbotronProps) => {
  const name: string = 'jumbotron';
  const { children, type, background } = props;

  return (
    <div className={name + (type ? ' ' + name + '--' + type : '')}>
      <img src={background} className="jumbotron__bg" />
      <div className="jumbotron__content">
        {children}
      </div>
    </div>
  );
};

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/modules/Jumbotron/Jumbotron.tsx